"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  importance: 'MEDIUM',
  periodType: 'Monthly',
  operator: 'not_equal_to',
  leftSide: {
    missingValueStrategy: 'NEVER_SKIP',
    description: '',
    expression: ''
  },
  rightSide: {
    missingValueStrategy: 'NEVER_SKIP',
    description: '',
    expression: ''
  }
};
exports.default = _default;
//# sourceMappingURL=validationRule.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2/model/config/model-defaults/validationRule.js
// module id = 1237
// module chunks = 0